var map = {
	"./BjornAxe.json": [
		589,
		7
	],
	"./BjornCircle.json": [
		590,
		8
	],
	"./BjornE.json": [
		591,
		9
	],
	"./BjornN.json": [
		592,
		10
	],
	"./BjornNE.json": [
		593,
		11
	],
	"./BjornNW.json": [
		594,
		12
	],
	"./BjornS.json": [
		595,
		13
	],
	"./BjornSE.json": [
		596,
		14
	],
	"./BjornSW.json": [
		597,
		15
	],
	"./BjornW.json": [
		598,
		16
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1171;
module.exports = webpackAsyncContext;